import Vue from "vue";
import Vuex from "vuex";
import { createStore } from 'vuex-extensions';
import { account } from "@/store/modules/account";
import { alert } from "@/store/modules/alert";
import { bank_accounts } from "@/store/modules/bank_accounts";
import { category } from "@/store/modules/category";
import {dataset} from "@/store/modules/dataset";
import { document } from "@/store/modules/document";
import { featureAccess } from "@/store/modules/feature_access";
import { gpt } from "@/store/modules/gpt";
import { insight } from "@/store/modules/insight";
import { invoice } from "@/store/modules/invoice";
import { items } from "@/store/modules/items";
import { job } from "@/store/modules/job";
import { loader } from "@/store/modules/loader";
import { member } from "@/store/modules/member";
import { project } from "@/store/modules/project";
import { ai_response } from "@/store/modules/recommender_response";
import { region } from "@/store/modules/region";
import { resource_metadata } from "@/store/modules/resource_metadata";
import { segment } from "@/store/modules/segment";
import { solution } from "@/store/modules/solution";
import { subscription } from "@/store/modules/subscription";
import { subscription_plans } from "@/store/modules/subscription_plans";
import {task} from "@/store/modules/task";
import { upload } from "@/store/modules/upload";
import { wallet } from "@/store/modules/wallet";
import { allowed_ips } from "./modules/allowed_ips";
import { session_list  } from "./modules/gpt_sessions";
import { notification } from "./modules/notification";
import { questionnaire } from "./modules/questionnaire";

Vue.use(Vuex);

const store = createStore(Vuex.Store, {
  modules: {
    alert,
    loader,
    account,
    solution,
    project,
    resource_metadata,
    category,
    dataset,
    subscription,
    invoice,
    segment,
    wallet,
    upload,
    bank_accounts,
    region,
    job,
    member,
    insight,
    gpt,
    document,
    task,
    items,
    ai_response,
    questionnaire,
    session_list,
    notification,
    subscription_plans,
    allowed_ips,
    featureAccess,
  },
});

export default store;
